export default {
  select: {
    id: 'dashboard_diagnosis_option_cta',
    defaultMessage: 'Select',
  },
}
